import { styled } from "@mui/material/styles"
import { Box, Stack, Typography } from "@mui/material"

interface ErrorBoxProps {
  children?: any
}

const ErrorDashBox = styled(Box)(
  ({ theme }) => `
    border: 3px solid ${theme.palette.error.main};
    color: ${theme.palette.error.main};
    border-radius: 8px;
  `
)

const ErrorComp = styled(Box)(
  ({ theme }) => `
    color: ${theme.palette.error.main};
    font-size:14px;
    line-height: 1.6em;
  `
)

export const ErrorBox = ({ children }: ErrorBoxProps) => {
  return (
    <>
      {children ? (
        <ErrorComp>
          <Stack direction="row" gap={1} mt={1}>
            <ErrorDashBox />
            <Typography> {children}</Typography>
          </Stack>
        </ErrorComp>
      ) : null}
    </>
  )
}
